import { createContext } from 'react';

export const EventContext = createContext({});
